import React, { useEffect } from "react";
import "./Detail.css";
import { useDispatch, useSelector } from "react-redux";
import { LedgerAction } from "../../redux/actions/authActons";
import { useNavigate } from "react-router-dom";
import DetailModal from "./DetailModal";

const Detail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ledgerlist } = useSelector((state) => state.authState);

  useEffect(() => {
    dispatch(LedgerAction());
    document.title = "Ledger Details | Ledger";
  }, [dispatch]);

  const handleRowClick = (invoice) => {
    navigate("/pdfview", {
      state: { pdfurl: `https://jipanik.shop/react_api/home/get_sales_pdf/${invoice}` },
    });
  };

  const getRowClass = (type) => {
    switch (type) {
      case "sale_invoice": return "row-sale";
      case "payment": return "row-payment";
      case "receipt": return "row-receipt";
      default: return "";
    }
  };

  if (!ledgerlist?.data || ledgerlist.data.length === 0) {
    return (
      <div className="empty-state">
        <div className="text-center">
          <div className="empty-icon">📂</div>
          <h4>Ledger Not Found</h4>
          <p className="text-muted">There are no transactions to display yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="detail-wrapper">
      <DetailModal />
      
      {/* Scroll to Bottom Floating Button */}
      <button 
        className="scroll-btn"
        onClick={() => window.scrollTo({ top: document.body.offsetHeight, behavior: "smooth" })}
      >
        <i className="bi bi-arrow-down" />
      </button>

      <div className="container py-4">
        <header className="ledger-header mb-4">
          <div>
            <span className="badge bg-soft-teal mb-2">Statement Account</span>
            <h2 className="fw-bold">Transactions for {ledgerlist?.name}</h2>
          </div>
        </header>

        <div className="table-responsive card shadow-sm border-0">
          <table className="table ledger-table mb-0">
            <thead>
              <tr>
                <th>Date & Type</th>
                <th className="text-end">Debit</th>
                <th className="text-end">Credit</th>
                <th className="text-end">Balance</th>
              </tr>
            </thead>
            <tbody>
              {ledgerlist.data.map((item, index) => (
                <tr 
                  key={index} 
                  className={getRowClass(item.type)} 
                  onClick={() => handleRowClick(item.invoice)}
                >
                  <td>
                    <div className="d-flex flex-column">
                      <span className="fw-bold text-dark">{item?.date}</span>
                      <small className="text-uppercase type-label">{item?.type?.replace('_', ' ')}</small>
                    </div>
                  </td>
                  <td className="text-end fw-semibold text-danger">
                    {item?.debit !== "0" ? `₹${item?.debit}` : "-"}
                  </td>
                  <td className="text-end fw-semibold text-success">
                    {item?.credit !== "0" ? `₹${item?.credit}` : "-"}
                  </td>
                  <td className="text-end fw-bold">
                    ₹{item?.balance}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Closing Balance Footer */}
        <div className="footer-spacer"></div>
        <div className="balance-footer shadow-lg">
          <div className="container d-flex justify-content-between align-items-center">
            <span className="label">Current Closing Balance</span>
            <span className="amount">₹{ledgerlist?.finalbalance}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Detail;